import * as React from 'react'
import * as ReactDOM from 'react-dom'
import AppView from '@app'

ReactDOM.render(<AppView />, document.getElementById('react-redux-app'))
